import { selectFeatureFlags } from 'core/userContext';
import { MESSAGING_METRICS, SMS_METRICS } from 'modules/billing/constants';
import { useProjectUsage } from 'modules/billing/hooks/useProjectUsage';
import { queryByFn } from 'modules/billing/utils';
import { useSelector } from 'react-redux';
import { SimpleIndexPage } from '../SimpleIndexPage/SimpleIndexPage';
import { MessagingTableFilters } from './MessagingTableFilters';
import { ProjectUsagePageActions } from './ProjectUsagePageActions';
import { createRowCell } from './TableCell';
import { useMemo } from 'react';

export const MESSAGING_PROJECT_USAGE_TEXT = {
  pageTitle: 'Messaging usage',
};

export const MessagingProjectUsage = () => {
  const { ExpandedChannelMetrics, WhatsAppMessageChannelGA } = useSelector(selectFeatureFlags);

  const metricNames = useMemo(
    () => [
      MESSAGING_METRICS.emailsSent,
      SMS_METRICS.mmsAttachmentsReceived,
      SMS_METRICS.mmsAttachmentsSent,
      SMS_METRICS.mmsAttachmentsTotal,
      SMS_METRICS.smsSegmentsReceived,
      SMS_METRICS.smsSegmentsSent,
      SMS_METRICS.smsSegmentsTotal,
      MESSAGING_METRICS.pushNotificationsSent,
      ...(ExpandedChannelMetrics
        ? [MESSAGING_METRICS.webPushNotificationsSent, MESSAGING_METRICS.inAppNotificationsSent]
        : []),
      ...(WhatsAppMessageChannelGA ? [MESSAGING_METRICS.whatsAppSent] : []),
    ],
    [ExpandedChannelMetrics, WhatsAppMessageChannelGA],
  );

  const { breadcrumb, columns, isLoading, rows } = useProjectUsage(metricNames);

  return (
    <SimpleIndexPage
      rows={rows}
      columns={columns}
      createRowCell={createRowCell}
      breadcrumb={breadcrumb}
      pageTitle={MESSAGING_PROJECT_USAGE_TEXT.pageTitle}
      pageActions={<ProjectUsagePageActions Filters={<MessagingTableFilters />} />}
      isLoading={isLoading}
      pluralResourceName="metrics"
      queryByFn={queryByFn}
      filterableColumns
      withHorizontalScroll
    />
  );
};
